import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from "rxjs/operators";
import {UpsertUserColumnRequest} from "it/primatoo/openapi/api/org/schemas/common/UpsertUserColumnRequest";
import {ListUserColumnsResponse} from "it/primatoo/openapi/api/org/schemas/common/ListUserColumnsResponse";
import {ListGenericReportResponse} from "it/primatoo/openapi/api/org/schemas/genericreport/ListGenericReportResponse";
import {CreateGenericReportRequest} from "it/primatoo/openapi/api/org/schemas/genericreport/CreateGenericReportRequest";
import {CreateResponse} from "it/primatoo/openapi/api/common/schemas/CreateResponse";
import {
  SetGenericReportForManageRequest
} from "it/primatoo/openapi/api/org/schemas/genericreport/SetGenericReportForManageRequest";
import {ApiClientConfig} from "../api-client-config";
import {ColumnWithLocalization} from "it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization";

@Injectable({
  providedIn: 'root'
})
export class GenericReportService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient) {
    this.endpoint = this.config.endPoint + '/api/org/v2/generic-reports/';
  }

  // @Mock({response: {kind: 'jsonFile', fileName: 'ListDataBreachTreatmentResponse'}})
  public findAll(): Observable<ListGenericReportResponse> {
    const url = this.endpoint;
    return this.httpClient.get<ListGenericReportResponse>(url);
  }

  public getColsEnabled(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns/`;
    return this.httpClient.get<ListUserColumnsResponse>(url).pipe(map(a => a.columns));
  }

  public setUserColumns(columnsConfigurationUpsertRequest: UpsertUserColumnRequest): Observable<void> {
    const url = this.endpoint + 'user-columns';
    return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  }

  public create(request: CreateGenericReportRequest): Observable<CreateResponse> {
    const url = this.endpoint;
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('X-Secret-Gen-Report', 'changeMe');
    return this.httpClient.post<CreateResponse>(url, request, {headers: header});
  }

  public manage(id: number, request: SetGenericReportForManageRequest): Observable<void> {
    const url = this.endpoint + `${id}/managed/`;
    return this.httpClient.patch<void>(url, request);
  }

  public delete(id: number): Observable<void> {
    const url = this.endpoint + `${id}/`;
    return this.httpClient.delete<void>(url);
  }

}
